import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_NKF_AEC_ENABLED, SET_NKF_AEC_READY, SET_NKF_AEC_SETTLING, SET_NKF_DEBUG_OVERLAY, SET_NKF_FORCE_BYPASS, SET_NKF_JANK, SET_NKF_MAKEUP_GAIN, SET_NKF_TX_METER, SET_NKF_LOG_PANEL, SET_NKF_MEDIA_STATS } from './actionTypes';
export const STORE_NAME = 'features/nkf-aec';
const DEFAULT_STATE = {
    enabled: true,
    debugOverlay: false,
    logPanel: false,
    ready: false,
    readyReason: '',
    settling: false,
    jank: false,
    mediaStats: false,
    forceBypass: 0,
    makeupGain: false, // ★2026-10-09 既定 OFF（createNkfAecEffect の _pendingMakeupGain と揃える）
    txMeter: false
};
// Persist only the ON/OFF choice; the debug overlay always starts hidden.
PersistenceRegistry.register(STORE_NAME, { enabled: true }, DEFAULT_STATE);
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_NKF_AEC_ENABLED:
            return {
                ...state,
                enabled: action.enabled
            };
        case SET_NKF_AEC_READY:
            return {
                ...state,
                ready: action.ready,
                readyReason: action.reason || '',
                settling: false
            };
        case SET_NKF_AEC_SETTLING:
            return {
                ...state,
                settling: true,
                readyReason: action.reason || ''
            };
        case SET_NKF_FORCE_BYPASS:
            return {
                ...state,
                forceBypass: action.pct
            };
        case SET_NKF_MEDIA_STATS:
            return {
                ...state,
                mediaStats: action.open
            };
        case SET_NKF_JANK:
            return {
                ...state,
                jank: action.running
            };
        case SET_NKF_TX_METER:
            return {
                ...state,
                txMeter: action.open
            };
        case SET_NKF_MAKEUP_GAIN:
            return {
                ...state,
                makeupGain: action.enabled
            };
        case SET_NKF_DEBUG_OVERLAY:
            return {
                ...state,
                debugOverlay: action.visible
            };
        case SET_NKF_LOG_PANEL:
            return {
                ...state,
                logPanel: action.visible
            };
        default:
            return state;
    }
});
